var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 -82 68 87",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1582 3.02734C57.6172 3.02734 71.2891-10.791 71.2891-31.5918C71.2891-66.1133 41.8457-80.4688 21.7285-80.4688C17.8223-80.4688 15.2832-79.0527 15.2832-76.3672C15.2832-75.3418 15.7715-74.2188 16.6016-73.2422C21.0938-67.8711 25.6348-61.5723 25.7324-53.8574C25.7324-52.2461 25.6836-50.8789 24.5117-48.7793L26.5625-49.1211C24.8535-54.8828 20.459-59.0332 16.1621-59.0332C14.3555-59.0332 13.1348-57.7148 13.1348-55.7617C13.1348-54.7852 13.4277-52.4414 13.4277-50.7812C13.4277-42.627 6.83594-37.3535 6.83594-23.3887C6.83594-7.51953 18.9453 3.02734 37.1582 3.02734ZM38.1348-7.71484C30.8594-7.71484 25.9766-12.1582 25.9766-18.75C25.9766-25.6348 30.9082-28.0762 31.543-32.5195C31.5918-32.9102 31.7871-33.0078 32.0801-32.7637C33.8867-31.1523 35.0098-29.1992 35.9375-26.9043C38.0371-29.7363 39.0137-35.791 38.4277-42.0898C38.3789-42.4805 38.623-42.6758 38.9648-42.5293C47.6074-38.5254 52.002-29.9805 52.002-22.3145C52.002-14.5508 47.4609-7.71484 38.1348-7.71484Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.b8afc6fe204b817024d1255e7237b979.svg";
export { ForwardRef as ReactComponent };